export const costItem: any = {
  serviceType_flight: "フライト",
  serviceType_hotel: "ホテル",
  serviceType_optional_tour: "オプショナルツアー",
  serviceType_railway: "鉄道",
  totalPrice: "料金",
  totalFee: "手数料",
};
